import { Location, FlattenLocation } from "../models/location"
import { ListItem } from 'lm-components';

export class QuoteStop
{
    id: string;
    stopType: string;
    stopDate: string;
    postalCode: string;
    country: string;
    state: string;
    city: string;
    orderIndex: number;
    stopAccessorials: string[] = [];
    longitude: number;
    latitude: number;

    constructor(stopType: string, stopDate?: string, stopFormValue?: StopFormValue, index?: number) {
        this.stopType = stopType;
        this.stopDate = stopDate;
        if (stopFormValue) {
            this.postalCode = stopFormValue.location.postalCode;
            this.city = stopFormValue.location.cityName;
            this.state = stopFormValue.location.stateAbbreviation;
            this.country = stopFormValue.location.countryAbbreviation;
            this.stopAccessorials = stopFormValue.services.map(service => service.code);
            this.longitude = stopFormValue.location.longitude;
            this.latitude = stopFormValue.location.latitude;
        }
        if (index !== null && index !== undefined) {
            this.orderIndex = index;
        }
    }
}

export class Stop extends QuoteStop
{
    locationName: string;
    streetAddress: string;
    pickupNumber: string;
    appointmentInformation: string;
}

export class StopDisplay extends Stop {
    typeOrder: string;
    address: string;
    stopAccessorialsDisplay: string;
}

export class StopFormValue {
    stopType: string;
    location: FlattenLocation;
    stopDate: string;
    services: ListItem[];
}

export class StopForUpdateComplete {
    stopId: string;
    locationName: string;
    streetAddress: string;
    pickupNumber: string;
    appointmentInformation: string;

    constructor() {}
}